import { defaultFiltersValue } from "Components/collaboration/milestone/Filters";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { CampaignActivity } from "types/campaign/activity";
import { encodeBase64 } from "utils/helpers";

interface CampaignPendingTasksProps {
    campaignActivity: CampaignActivity;
    loading?: boolean;
}

const CampaignPendingTasks = ({ campaignActivity, loading = false }: CampaignPendingTasksProps) => {
    const steps = Object.entries(campaignActivity.steps ?? {});
    const totalPendingTasks = steps.reduce((acc, [, step]) => acc + step.count, 0);

    const getFiltersQuery = (data: Record<string, unknown>) => {
        const encodedData = encodeBase64({ ...defaultFiltersValue, ...data });
        return `?filters=${encodedData}`;
    };

    const baseFilters = {
        campaign_id: campaignActivity.id,
        campaign: { label: campaignActivity.name, value: campaignActivity.id },
        assignee: "hub",
    };

    return (
        <div className="d-flex justify-content-between align-items-center flex-column flex-md-row p-3">
            <h6 className="campaign-card-pending-task-heading mb-0">
                <Link
                    className="unset-all cursor-pointer"
                    to={{ pathname: "/tasks", search: getFiltersQuery(baseFilters) }}
                >
                    Pending Tasks ({totalPendingTasks})
                </Link>
            </h6>
            {steps.length > 0 ? (
                <div className="swiper-area">
                    <Swiper
                        modules={[Navigation]}
                        spaceBetween={10}
                        navigation={{
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        }}
                        pagination={true}
                        breakpoints={{
                            640: { slidesPerView: 2, spaceBetween: 8 },
                            768: { slidesPerView: 2, spaceBetween: 8 },
                            1024: { slidesPerView: 3, spaceBetween: 8 },
                        }}
                        className="mySwiper navigation-swiper overflow-y-visible"
                    >
                        {loading ? (
                            Array.from({ length: 4 }).map((_, i) => (
                                <SwiperSlide key={i}>
                                    <Skeleton height={80} className="rounded-4" />
                                </SwiperSlide>
                            ))
                        ) : (
                            steps.map(([slug, step], index) => (
                                <SwiperSlide key={index}>
                                    <Link
                                        to={{
                                            pathname: "/tasks",
                                            search: getFiltersQuery({
                                                ...baseFilters,
                                                gig_step: slug,
                                                gig_step_obj: { value: slug, label: step.name },
                                            }),
                                        }}
                                    >
                                        <div className="pending-step-card-slide">
                                            <h5 className="w-100 text-truncate">{step.name}</h5>
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1">
                                                    <h4 className="mb-0 text-primary d-flex justify-content-between align-items-center w-100">
                                                        <span className="counter-value">{step.count}</span>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </SwiperSlide>
                            ))
                        )}
                    </Swiper>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-center me-md-5">
                    <h6 className="m-0 me-md-5 pe-md-4">No Pending Tasks</h6>
                </div>
            )}
        </div>
    );
};

export default CampaignPendingTasks;
